import { takeLatest } from 'redux-saga'
import { put, fork, take, call, all } from 'redux-saga/effects'

import actionTypes from '../actions/actionTypes'
import { myLibrarySync } from '../../sync'
import callAny from 'redux/sagas/helpers/call_any'
import myLibraryActions from 'redux/actions/my_library_actions'
import formatError from './helpers/error_formatter'
import overlayTypes from 'helpers/enums/overlayTypes'
import userSync from 'sync/user_sync'
import actionUserTypes from 'helpers/enums/actionUserTypes'

function *firstLessonFilePicked(action) {
	yield fork(firstLessonFileUpload, action)
	yield all([
		take(actionTypes.MY_LIBRARY_FIRST_LESSON_PRESENTATION_PUBLISHED),
		take(actionTypes.MY_LIBRARY_FIRST_LESSON_ANIMATION_LOADING_COMPLETED),
		take(actionTypes.MY_LIBRARY_LESSONS_FETCHED),
	])
	yield put(myLibraryActions.firstLessonCompleted())
}

function *firstLessonFileUpload(action) {
	try {
		yield callAny(userSync.loginNotification,
			overlayTypes.FEATURE_FIRST_LESSON_OVERLAY_ID,
			null,
			actionUserTypes.ACTION_CONTINUE
		)
		const response = yield callAny(myLibrarySync.firstLessonUploadFile, action.file['files'][0])
		yield callAny(myLibrarySync.firstLessonPresentationPublish, response.payload.presentationId)
		yield put(myLibraryActions.firstLessonPresentationPublished(response.payload))
	} catch (error) {
		const serverError = formatError(error)
		yield put(myLibraryActions.firstLessonFileUploadedError(serverError))
	}
}

function *firstLessonClosed() {
	try {
		yield callAny(userSync.loginNotification,
			overlayTypes.FEATURE_FIRST_LESSON_OVERLAY_ID,
			null,
			actionUserTypes.ACTION_CANCEL
		)
	} catch (error) {
		const serverError = formatError(error)
		yield put(myLibraryActions.firstLessonFileUploadedError(serverError))
	}
}

function *firstLessonInitialize() {
	yield call(myLibrarySync.firstLessonLoadAsset)
}

export default [
	takeLatest(actionTypes.MY_LIBRARY_FIRST_LESSON_FILE_PICKED, firstLessonFilePicked),
	takeLatest(actionTypes.MY_LIBRARY_FIRST_LESSON_CLOSED, firstLessonClosed),
	takeLatest(actionTypes.MY_LIBRARY_FIRST_LESSON_INITIALIZE, firstLessonInitialize),
]


export {
	firstLessonFilePicked,
	firstLessonFileUpload,
	firstLessonClosed,
}
